import axios from 'axios'

axios.defaults.withCredentials = true

export default {
  get: function (mode, id) {
    let url = ''
    if (mode === 'subscription') {
      url = `${window.apiURL}api/user/subscription/${id}`
    } else {
      url = `${window.apiURL}api/user/payout/${id}`
    }
    return axios.get(url)
  }
}



// WEBPACK FOOTER //
// ./src/services/receipts.js